import { View } from "@gluestack-ui/themed";
import { Platform } from "react-native";
import { useMemo } from "react";
import { Button } from "@repo/core/components/core/Button";
import { ScaffoldFooterProps } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter/types";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import {
  DEFAULT_FOOTER_VISUAL_SPACING,
  getFooterBottomPadding
} from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter/utils";

export const ScaffoldFooter = ({
  primaryAction = "primary",
  primaryVariant,
  primarySize = "xl",
  primaryText,
  primaryIsDisabled,
  primaryOnPress,
  primaryIsLoading,
  primaryButtonProps,

  secondaryText,
  secondaryAction = "negative",
  secondarySize = "xl",
  secondaryVariant = "outline",
  secondaryIsDisabled,
  secondaryOnPress,
  secondaryIsLoading,
  secondaryButtonProps
}: ScaffoldFooterProps) => {
  const { isTabletOrWeb, isMobile } = useDimensions();
  const insets = useSafeAreaInsets();
  const buttonWidth =
    isTabletOrWeb && primaryText && secondaryText ? "$1/2" : "$full";

  const bottomPadding = useMemo(() => {
    const visualSpacing =
      Platform.OS === "web" ? 24 : DEFAULT_FOOTER_VISUAL_SPACING;

    return getFooterBottomPadding(Platform.OS, insets.bottom, visualSpacing);
  }, [insets.bottom]);

  return (
    <View
      w="$full"
      gap="$4"
      flexDirection={!isMobile ? "row-reverse" : "column"}
      pt={isMobile ? "$0" : "$12"}
      pb={bottomPadding}
      justifyContent="flex-end"
    >
      {primaryText ? (
        <Button
          size={primarySize}
          isDisabled={primaryIsDisabled}
          action={primaryAction}
          variant={primaryVariant}
          isLoading={primaryIsLoading}
          text={primaryText}
          textStyle={{
            ...primaryButtonProps?.textStyle,
            fontFamily: "$heading",
            fontWeight: 600,
            fontSize: 16
          }}
          w={buttonWidth}
          onPress={primaryOnPress}
          {...primaryButtonProps}
        />
      ) : null}
      {secondaryText ? (
        <Button
          variant={secondaryVariant}
          isDisabled={secondaryIsDisabled}
          action={secondaryAction}
          size={secondarySize}
          isLoading={secondaryIsLoading}
          text={secondaryText}
          onPress={secondaryOnPress}
          textStyle={{
            ...secondaryButtonProps?.textStyle,
            fontFamily: "$heading",
            fontWeight: 600,
            fontSize: 16
          }}
          w={buttonWidth}
          {...secondaryButtonProps}
        />
      ) : null}
    </View>
  );
};
